import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import {gettext} from 'topmeteo/utils/i18n';

import createEventData from 'topmeteo/google-analytics/event';

import {toggleShowFavouritesOnly} from 'topmeteo/general/actionCreators';

const ShowAllProductsLabel = gettext('Show all Products');
const ShowFavouritesOnlyLabel = gettext('Show Favorites Only');

const className = showFavouritesOnly => classNames('link', showFavouritesOnly ? 'all' : 'none');

const eventData = (showFavouritesOnly, type) => createEventData(
    type, 'click', showFavouritesOnly ? 'Show All Products' : 'Show Favorites Only'
);

const FavouritesOnlyToggle = ({showFavouritesOnly, type, onClick}) => (
    <a className={className(showFavouritesOnly)} onClick={onClick} {...eventData(showFavouritesOnly, type)}>
        {showFavouritesOnly ? ShowAllProductsLabel : ShowFavouritesOnlyLabel}
    </a>
);

const mapStateToProps = ({showFavouritesOnly}) => ({showFavouritesOnly});

const mapDispatchToProps = dispatch => ({
    onClick: () => dispatch(toggleShowFavouritesOnly),
});

export default connect(mapStateToProps, mapDispatchToProps)(FavouritesOnlyToggle);
